import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { getAppParams } from '@/stores/app'

import { loginRoutes } from './modules/login'
import { tabHomeRoutes } from './modules/tabHome'
import { homeRoutes } from './modules/home'
import { profileRoutes } from './modules/profile'
import { meRoutes } from './modules/me'
import { webRoutes } from './modules/web'
import { ersRoutes } from './modules/ers'
import { bindDeviceRoutes } from './modules/bindDevice'

const routes: RouteRecordRaw[] = [
  ...loginRoutes,
  ...tabHomeRoutes,
  ...homeRoutes,
  ...profileRoutes,
  ...meRoutes,
  ...webRoutes,
  ...ersRoutes,
  ...bindDeviceRoutes,
  {
    // 未匹配路由 → 404 页面
    path: '/:pathMatch(.*)*',
    name: 'notFound',
    component: () => import('@/pages/NotFound/index.vue'),
  },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
})

// 全局鉴权守卫：除公开路由外，未登录一律跳登录页。
const PUBLIC_PREFIXES = ['/login', '/email-login', '/email-captcha', '/download', '/overseas', '/ers']
router.beforeEach((to) => {
  if (to.name === 'notFound' || to.path === '/') return true
  if (PUBLIC_PREFIXES.some((p) => to.path === p || to.path.startsWith(p + '/'))) {
    return true
  }
  if (!getAppParams().token) return { path: '/login' }
  return true
})
